// extracted by mini-css-extract-plugin
export default {"horizontalSeparator":"InternalTests_horizontalSeparator__NmozA","grid":"InternalTests_grid__2u1QU"};